import React from 'react';

import ProjectLogo_HB from '../Images/Projects/HealthyBreak/Icon.png';
import ScreenShot_HB_1 from '../Images/Projects/HealthyBreak/ScreenShot_1.jpg';
import ScreenShot_HB_2 from '../Images/Projects/HealthyBreak/ScreenShot_2.jpg';
import ScreenShot_HB_3 from '../Images/Projects/HealthyBreak/ScreenShot_3.jpg';
import ScreenShot_HB_4 from '../Images/Projects/HealthyBreak/ScreenShot_4.jpg';

import ProjectLogo_TTT3D from '../Images/Projects/TicTacToe/Icon.png';
import ScreenShot_TTT3D_1 from '../Images/Projects/TicTacToe/ScreenShot_1.jpg';
import ScreenShot_TTT3D_2 from '../Images/Projects/TicTacToe/ScreenShot_2.jpg';
import ScreenShot_TTT3D_3 from '../Images/Projects/TicTacToe/ScreenShot_3.jpg';
import ScreenShot_TTT3D_4 from '../Images/Projects/TicTacToe/ScreenShot_4.jpg';

import ProjectLogo_PV from '../Images/Projects/PerspectiveView/Icon.png';
import ScreenShot_PV_1 from '../Images/Projects/PerspectiveView/ScreenShot_1.jpg';
import ScreenShot_PV_2 from '../Images/Projects/PerspectiveView/ScreenShot_2.jpg';
import ScreenShot_PV_3 from '../Images/Projects/PerspectiveView/ScreenShot_3.jpg';
import ScreenShot_PV_4 from '../Images/Projects/PerspectiveView/ScreenShot_4.jpg';

const getOnPM = 'Get on Play Market';

function getProjectDesc(id){
    switch(id){
        case 'HB':
            return (
                <>
                <p>Healthy break is an android application for people with sedentary work. Such lifestyle can cause health problems, and this app can help you avoid them.</p>
                <p>Application contains different breaks that you can take during your work to take a rest for your body.</p>
                </>
            );
        case 'TTT3D':
            return (
                <>
                <p>Tic Tac Toe 3D is a puzzle, similar to original game, but in three-dimensional space and with two gameplay field sizes: X3 as in original game and X5.</p>
                <p>One more dimension creates much more cells to control and much more combination to win.</p>  
                </>
            );          
        case 'PV':
            return (
                <>
                <p>Puzzle for Android in three-dimensional space. You have to select correct cells of game field using it’s projections. The game can help to improve visualisation skills and spend time with fun and benefit.</p>                    
                </>
            );

    default:
        return (
            <>
            </>
        );
    }
}

function getProjectData(id){
    switch(id){
        case 'HB':            
            return {
                projectName: 'Healthy break',
                description: getProjectDesc(id),
                logo: ProjectLogo_HB,
                screenShots: [ScreenShot_HB_1, ScreenShot_HB_2, ScreenShot_HB_3, ScreenShot_HB_4],
                storeLinks: [[getOnPM, 'https://play.google.com/store/apps/details?id=com.OleksiiKoval.healthybreak']]
            }
        case 'TTT3D':
            return {
                projectName: 'Tic Tac Toe 3D',
                description: getProjectDesc(id),
                logo: ProjectLogo_TTT3D,
                screenShots: [ScreenShot_TTT3D_1, ScreenShot_TTT3D_2, ScreenShot_TTT3D_3, ScreenShot_TTT3D_4],
                storeLinks: [[getOnPM, 'https://play.google.com/store/apps/details?id=com.OleksiiKoval.TicTacToe3D']]
            }
        case 'PV':
            return {
                projectName: 'Perspective view',
                description: getProjectDesc(id),
                logo: ProjectLogo_PV,
                screenShots: [ScreenShot_PV_1, ScreenShot_PV_2, ScreenShot_PV_3, ScreenShot_PV_4],
                storeLinks: [[getOnPM, 'https://play.google.com/store/apps/details?id=com.OleksiiKoval.PerspectiveView']]
            }

    default:
        return null;
    }
}

export default getProjectData;